import { m8API } from 'services/production/m8';
import { normalizeM8PartnerDTO } from 'services/production/utils/normalizeM8PartnerDTO';
import { normalizeM8PartnerClientDTO } from 'services/production/utils/normalizeM8PartnerClientDTO';
import { GetPartnerManagerDataService } from 'types/services';
import { normalizeM8PartnerBalance } from '../utils/normalizeM8PartnerBalance';
import { createPartnerFinances } from 'utils/partnerFinancesUtils';
import { PartnerFinanceMonthReport } from 'types/partnerFinance';
import { normalizeM8PartnerIncomeHistoryRecord } from '../utils/normalizeM8PartnerIncomeHistory';

export const getPartnerManagerData: GetPartnerManagerDataService = async (
  partnerId
) => {
  const m8PartnerDTO = await m8API.admin.getPartner({ idPartner: partnerId });

  const m8PartnerBalance = await m8API.admin.getPartnerBalance({
    idPartner: partnerId,
  });

  const partnerFinanceMonthReports: PartnerFinanceMonthReport[] = [];

  for (let page = 0; page >= 0; page += 1) {
    const m8PartnerIncomeHistoryRecords = await m8API.admin.getPartnerIncomeHistory(
      {
        idPartner: partnerId,
        page,
      }
    );

    if (m8PartnerIncomeHistoryRecords.length > 0) {
      m8PartnerIncomeHistoryRecords.forEach((m8PartnerIncomeHistoryRecord) => {
        partnerFinanceMonthReports.push(
          normalizeM8PartnerIncomeHistoryRecord(
            m8PartnerIncomeHistoryRecord
          ).toPartnerFinanceMonthReport()
        );
      });
    } else {
      break;
    }
  }

  const m8PartnerClientDTOs = await m8API.admin.getPartnerClients({
    idPartner: partnerId,
  });

  const avatarURL = await m8API.admin.getPartnerAvatarURL({
    idPartner: partnerId,
  });

  return {
    partner: normalizeM8PartnerDTO(m8PartnerDTO).toPartner(
      avatarURL || undefined
    ),
    partnerProfile: normalizeM8PartnerDTO(m8PartnerDTO).toPartnerProfile(
      avatarURL || undefined
    ),
    partnersTableItem: normalizeM8PartnerDTO(
      m8PartnerDTO
    ).toPartnersTableItem(),
    partnerCode: m8PartnerDTO.partnerCode || '',
    partnerManagerClients: m8PartnerClientDTOs.map((m8PartnerClientDTO) =>
      normalizeM8PartnerClientDTO(m8PartnerClientDTO).toPartnerManagerClient()
    ),
    partnerBlocked: m8PartnerDTO.partnerStatus === 'BLOCKED',
    partnerFinances: m8PartnerBalance
      ? normalizeM8PartnerBalance(m8PartnerBalance).toPartnerFinances()
      : createPartnerFinances(),
    partnerFinanceMonthReports,
  };
};
